import React, { useEffect, useRef } from 'react';
import connect from "react-redux/es/connect/connect";
import { setCurrentNavPage } from "actions";
import NotFoundPage from "../components/NotFoundPage";
import * as lottie from 'lottie-web';
import { S3_FOLDER_URL } from 'Config';

const NotFoundFrame = () => {

  const animationContainerRef = useRef(null);
  const animRef = useRef(null);

  const intiAnimation = () => {
    if (animRef.current) {
      animRef.current.destroy();
    }

    animRef.current = lottie.loadAnimation({
      container: animationContainerRef.current,
      renderer: 'svg',
      loop: 1,
      autoplay: true,
      path: `${S3_FOLDER_URL}/billing/assets/animations/billing-header.json`,
    });
  };

  const handleClickToPause = () => {
    if (!animRef.current) {
      return;
    }
    if (animRef.current.isPaused) {
      animRef.current.goToAndPlay(0);
    } else {
      animRef.current.pause();
    }
  };

  // componentDidMount + componentWillUnmount
  useEffect(() => {
    intiAnimation();

    return () => {
      if (animRef.current) {
        animRef.current.destroy();
      }
    };
  }, []);

  return (
    <NotFoundPage isErrorPage={true} />
  );
};

const mapStateToProps = state => ({});

const mapDispatchToProps = {
  setCurrentNavPage,
};

export default connect(mapStateToProps, mapDispatchToProps)(NotFoundFrame);


// WEBPACK FOOTER //
// ./app/pages/NotFoundFrame.js